import { useGetSmartLinkQuery } from '../../../../redux/api/fymAPI';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';

/**
 * The public address of the smartlink a post points at.
 *
 * A web share intent needs a url, and a post only carries the smartlink's id.
 * Undefined means there is nothing to share — either the post has no smartlink
 * or the page has never been published.
 */
export function useSmartLinkShareUrl(smartLinkId: number | null): string | undefined {
  const accountId = useAccountId();
  const isSkipped = accountId === null || smartLinkId === null;

  const { data } = useGetSmartLinkQuery(
    { accountId: accountId ?? 0, smartLinkId: smartLinkId ?? 0 },
    { skip: isSkipped }
  );

  return data?.smartLink.shareUrl ?? undefined;
}
